import { render, staticRenderFns } from "./EmploymentStatusCreateEditModal.vue?vue&type=template&id=1f4ca31c&scoped=true&"
import script from "./EmploymentStatusCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./EmploymentStatusCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ca31c",
  null
  
)

export default component.exports